/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlControlComponent } from './ControlControlComponent';
import {
    ControlControlComponentFromJSON,
    ControlControlComponentFromJSONTyped,
    ControlControlComponentToJSON,
} from './ControlControlComponent';

/**
 * 
 * @export
 * @interface ControlControlComponentsResponse
 */
export interface ControlControlComponentsResponse {
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlControlComponentsResponse
     */
    pre_purchase_components?: { [key: string]: Array<ControlControlComponent>; };
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlControlComponentsResponse
     */
    active_components?: { [key: string]: Array<ControlControlComponent>; };
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlControlComponentsResponse
     */
    expired_components?: { [key: string]: Array<ControlControlComponent>; };
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlControlComponentsResponse
     */
    expiring_subscriptions?: { [key: string]: Array<ControlControlComponent>; };
}

/**
 * Check if a given object implements the ControlControlComponentsResponse interface.
 */
export function instanceOfControlControlComponentsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlControlComponentsResponseFromJSON(json: any): ControlControlComponentsResponse {
    return ControlControlComponentsResponseFromJSONTyped(json, false);
}

export function ControlControlComponentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlControlComponentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pre_purchase_components': !exists(json, 'pre_purchase_components') ? undefined : json['pre_purchase_components'],
        'active_components': !exists(json, 'active_components') ? undefined : json['active_components'],
        'expired_components': !exists(json, 'expired_components') ? undefined : json['expired_components'],
        'expiring_subscriptions': !exists(json, 'expiring_subscriptions') ? undefined : json['expiring_subscriptions'],
    };
}

export function ControlControlComponentsResponseToJSON(value?: ControlControlComponentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pre_purchase_components': value.pre_purchase_components,
        'active_components': value.active_components,
        'expired_components': value.expired_components,
        'expiring_subscriptions': value.expiring_subscriptions,
    };
}

